import React from "react";
import { Modal } from "react-bootstrap";
import { Button, Form , Input} from "antd";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { useTagsStore } from "./store";

function AddTagModal({ modalShow, setModalShow }) {
  const [form] = Form.useForm();
  const { setToaster } = useToast();

  const { fetchAllTagData, addTagData } = useTagsStore();

  const handleModalClose = () => {
    form.resetFields();
    setModalShow(false);
  };

  const onSubmit = async (data) => {
    const trimmedData = {};
    for (const key in data) {
      if (key === "tag_slug")
        trimmedData[key] = data[key]?.trim()?.toLowerCase();
      else trimmedData[key] = data[key].trim();
    }
    addTagData(trimmedData, setToaster, fetchAllTagData, handleModalClose);
  };

  return (
    <Modal
      show={modalShow}
      onHide={() => setModalShow(false)}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Add Community
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Form
            form={form}
            layout="vertical"
            name="add tag"
            onFinish={onSubmit}
          >
            <Form.Item
              label="Tag Name"
              name="tag_name"
              rules={[
                {
                  required: true,
                  message: "Please fill this",
                },
                {
                  whitespace: true,
                  message: "Please fill this",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Slug"
              name="tag_slug"
              rules={[
                {
                  required: true,
                  message: "Please fill this",
                },
                {
                  whitespace: true,
                  message: "Please fill this",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item style={{ textAlign: "center" }}>
              <Button type="primary" htmlType="submit">
                Add Tag
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => setModalShow(false)}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddTagModal;
